<template>
  <div class="list-con backgroundImg">
    <ul>
      <li
        v-for="(item,i) in list"
        :key="i"
        @click="buy(item.listingId)"
        :data-stat="`推荐商品${type}-${i}-${item.listingName}`"
      >
        <img class="label" src="//i0.ulecdn.com/i/event/2019/0919/main/images/yz_label.png" alt />
        <a class="js_shop" :class="item.storage==0?'soldout':''">
          <div class="img">
            <img alt class="test-lazyload" v-lazy="item.imgUrl.replace(/^http(s)?:/, '')" />
          </div>
          <h5>{{item.listingName}}</h5>
          <p>
            ￥
            <span v-if="type==2">{{item.groupbuyPrice}}</span>
            <span v-else-if="type==3||type==4||type==1">{{item.skillPrice}}</span>
            <span v-else>{{item.minPrice}}</span>
            <img
              v-show="item.listingTagSet&&item.listingTagSet.join(',').indexOf('1666')!=-1"
              class="tag1666"
              src="../../assets/images/xxpf.png"
              alt
            />
          </p>
          <div v-show="isStart">
            <div class="but_go" v-show="type!=2">
              <span>立即购买</span>
            </div>
            <div class="but_go" v-show="type==2">
              <span>立即开团</span>
            </div>
            <div class="but_go2">
              <span>已售完</span>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from "vue";
import * as URL from "../../assets/js/url.js";
export default {
  props: ["list", "type", "isStart"],
  data() {
    return {
      scrollHeight: document.documentElement.clientHeight - 64 + "px",
      url: {
        uleVi: "uleMobile://uleVi_", //客户端vi页
        uleH5: "//item." + URL.doMain + "/mitem/item/view/" //新浏览器h5
      }
    };
  },
  mounted() {},
  methods: {
    buy(listingId) {
      if (this.BASE.$browser().ule) {
        location.href = this.url.uleVi + listingId;
      } else {
        location.href = this.url.uleH5 + listingId;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.list-con {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  // height: 4rem;
  border-left: 0.1rem solid #cb3d17;
  border-right: 0.1rem solid #cb3d17;
  border-bottom: 0.1rem solid #cb3d17;
  border-radius: 0.16rem;
  z-index: 0;
  margin-top: -0.2rem;
  background-color: #f1ca8f;
  padding: 0.4rem 0.1rem 0;
  ul {
    width: 100%;
    overflow: hidden;
    .soldout {
      .img::after {
        position: absolute;
        display: block;
        content: "";
        background: url("../../assets/images/soldout.png") no-repeat center
          center;
        background-size: 75px 75px;
        width: 75px;
        height: 75px;
        left: 50%;
        top: 50%;
        margin-left: -37.5px;
        margin-top: -37.5px;
      }
      .but_go {
        display: none;
      }
      .but_go2 {
        display: block;
        text-align: center;
        height: 0.72rem;
        position: relative;
        padding: 0 0.3rem 0.2rem;
        box-sizing: border-box;
        span {
          box-sizing: border-box;
          width: 100%;
          height: 0.5rem;
          color: #999;
          font-size: 0.24rem;
          text-align: center;
          line-height: 0.5rem;
          background: #ddd;
          margin: 0 auto;
          display: block;
          border-radius: 0.26rem;
        }
      }
    }

    li {
      width: 49%;
      background-color: #fff;
      float: left;
      position: relative;
      border-radius: 0.1rem;
      overflow: hidden;
      margin-bottom: 0.2rem;
      .but_go3 {
        display: block;
        text-align: center;
        height: 0.72rem;
        position: relative;
        padding: 0 0.3rem 0.2rem;
        box-sizing: border-box;
        span {
          box-sizing: border-box;
          width: 100%;
          height: 0.5rem;
          color: #fff;
          font-size: 0.24rem;
          text-align: center;
          line-height: 0.5rem;
          background: #a0a0a0;
          margin: 0 auto;
          display: block;
          border-radius: 0.26rem;
        }
      }
      .label {
        position: absolute;
        width: 1.46rem;
        left: 0.06rem;
        top: 0;
        z-index: 1;
      }
      .img {
        width: 100%;
        display: block;
        position: relative;
        box-sizing: border-box;
        padding: 0.14rem 0.14rem 0;

        img {
          height: 100%;
          width: 100%;
          max-height: 3.02rem;
          display: block;
        }
      }

      h5 {
        white-space: normal;
        font-size: 0.22rem;
        color: #333;
        padding: 0.1rem 0.2rem 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        height: 0.6rem;
        line-height: 1.4;
        font-family: "Microsoft YaHei";
      }

      p {
        padding: 0.3rem 0.2rem 0;
        font-size: 0.24rem;
        color: #ee0000;
        margin-bottom: 0.2rem;
        font-family: "Arial";
        position: relative;
        height: 0.4rem;
        .tag1666 {
          width: 0.32rem;
          height: 0.32rem;
          display: inline-block;
          margin-left: 0.1rem;
        }
        span {
          font-size: 0.3rem;
        }
        .shouy {
          position: absolute;
          right: 0.2rem;
          font-size: 0.18rem;
          height: 0.35rem;
          line-height: 0.35rem;
          border-radius: 0.2rem 0 0 0.2rem;
          padding: 0 0.1rem;
          background-color: #ff8a00;
          color: #fff;
        }
      }
      .but {
        display: block;
        text-align: center;
        img {
          display: inline-block;
          width: 3.08rem;
        }
      }
      .but_go2 {
        display: none;
      }
      .but_go {
        display: block;
        text-align: center;
        height: 0.72rem;
        position: relative;
        padding: 0 0.3rem 0.2rem;
        box-sizing: border-box;
        span {
          box-sizing: border-box;
          width: 100%;
          height: 0.5rem;
          color: #fff;
          font-size: 0.24rem;
          text-align: center;
          line-height: 0.5rem;
          background: linear-gradient(90deg, #fd2618 0%, #fb5315 100%);
          margin: 0 auto;
          display: block;
          border-radius: 0.26rem;
        }
      }
    }
    li:nth-of-type(2n) {
      float: right;
    }
  }
}
.backgroundImg {
  background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/bg-gloab.png")
    repeat-y;
  background-size: 100% auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/list.vue